type MediaSource = {
  avatarUrl?: string | null
  avatar_url?: string | null
  photo_url?: string | null
  logo_url?: string | null
  profile_photo_url?: string | null
}

function pickFirstDefined(values: Array<string | null | undefined>): string | null {
  for (const value of values) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value
    }
  }

  return null
}

export function getCircularAvatarUrl(
  source: MediaSource | null | undefined,
  fallbackUrl?: string | null
): string | null {
  if (!source) return fallbackUrl ?? null

  return (
    pickFirstDefined([
      source.profile_photo_url,
      source.avatarUrl,
      source.avatar_url,
      source.photo_url,
      source.logo_url,
    ]) ?? fallbackUrl ?? null
  )
}

export function getInstitutionBrandImageUrl(
  source: Pick<MediaSource, 'logo_url' | 'profile_photo_url'> | null | undefined,
  fallbackUrl?: string | null
): string | null {
  if (!source) return fallbackUrl ?? null

  return pickFirstDefined([source.logo_url, source.profile_photo_url]) ?? fallbackUrl ?? null
}
